import { Head } from "@inertiajs/react";
import AuthLayout from "@/layouts/auth-layout";

function GuidesIndex({ guides = [] }) {
  const [featuredGuide] = guides;

  return (
    <>
      <Head title="Guides" />

      <section className="products-page workspace-guides-page">
        <header className="workspace-guides-page__intro">
          <div className="workspace-section__eyebrow">Testvisning</div>
          <h2 className="workspace-section__title">
            {featuredGuide?.title || "Guide"}
          </h2>
          <p className="workspace-guide-card__description">
            {featuredGuide?.description || "Indlejret guide til hurtig afprøvning i arbejdsrummet."}
          </p>
        </header>

        {featuredGuide?.embed_url ? (
          <section className="workspace-guide-section workspace-guide-section--standard">
            <div className="workspace-guide-section__header">
              <div className="workspace-section__eyebrow">Standard</div>
            </div>

            <div className="workspace-guide-frame">
              <iframe
                src={featuredGuide.embed_url}
                title={featuredGuide.title}
                width="800"
                height="679"
                allow="fullscreen"
                allowFullScreen
                loading="lazy"
                className="workspace-guide-embed"
              />
            </div>
          </section>
        ) : null}

        {featuredGuide?.scrollable_embed_url ? (
          <section className="workspace-guide-section workspace-guide-section--full">
            <div className="workspace-guide-section__header">
              <div className="workspace-section__eyebrow">Fuldbredde</div>
            </div>

            <div className="workspace-guide-frame workspace-guide-frame--full">
              <iframe
                src={featuredGuide.scrollable_embed_url}
                title={`${featuredGuide.title} scrollable`}
                width="100%"
                height="800"
                allow="fullscreen"
                allowFullScreen
                loading="lazy"
                className="workspace-guide-embed workspace-guide-embed--full"
              />
            </div>
          </section>
        ) : null}
      </section>
    </>
  );
}

GuidesIndex.layout = (page) => {
  const { layout_header: layoutHeader } = page.props;

  return (
    <AuthLayout
      header={{
        breadcrumbs: [{ label: layoutHeader?.breadcrumb || "Guides" }],
        title: layoutHeader?.title || "Guides"
      }}
    >
      {page}
    </AuthLayout>
  );
};

export default GuidesIndex;
